import { PageLayout } from "@/shared/ui/layouts/PageLayout";
// import { SectionLayout } from "@/shared/ui/layouts/SectionLayout";
// import Typography from "@/shared/ui/Typography";
import * as React from "react";
import { MainSection } from "./sections/MainSection";
import { CustomSliderSection } from "./sections/CustomSliderSection";
import { PrivateBrokerConsultation } from "@/widgets/private_broker_consultation/ui";
import { NewApplicationSection } from "./sections/NewApplicationSection";
import { MortgageSection } from "../../../widgets/mortgage_section/ui";
import { MapSection } from "./sections/MapSection";
import { GetBestApplicationSection } from "@/widgets/get_best_application/ui";
import { useScrollToTop } from "@/shared/hooks/useScrollToTop";
import { useAppSelector } from "@/app/store/hooks";
import { selectAllProjects } from "@/entities/projects/model/selects";
import { cn } from "@/shared/lib/utils";

import UpArrow from "@/assets/icons/arrow/select.svg?react";
import Man from "@/assets/icons/app/man.svg?react";
import Woman from "@/assets/icons/app/woman.svg?react";

const btnGeneralStyles = 'flex justify-center items-center w-[40px] h-[40px] md:w-[50px] md:h-[50px] rounded-full cursor-pointer overflow-hidden';

export function MainPage() {
    
    const scrollToTop = useScrollToTop();
    const projects = useAppSelector(selectAllProjects);

    React.useEffect(() => {
        scrollToTop();
    }, [scrollToTop]);

    const handleBotBtn = () => {

    }

    const handleScrollToTop = () => {
        scrollToTop()
    }

    const handleOperatorBtn = () => {

    }

    return (
        <PageLayout>
            <MainSection />

            <CustomSliderSection 
                projects={projects}
            />

            <GetBestApplicationSection />

            <MapSection />

            <NewApplicationSection 
                projects={projects}
            />

            <MortgageSection />

            <PrivateBrokerConsultation />
            
            <div className="fixed right-[10px] md:right-[32px] lg:right-[30px] bottom-[32px] z-10 flex flex-col gap-[8px] md:gap-[16px]">

                <div 
                    className={cn(btnGeneralStyles, 'border border-[#11FEFE]')}
                    onClick={handleBotBtn}
                >
                    <Man className="w-full h-full"/>
                </div>
                <div 
                    className={cn(btnGeneralStyles, 'border border-black bg-white')}
                    onClick={handleScrollToTop}
                >
                    <UpArrow className="w-[16px] h-[8.5px] md:w-[20px] md:h-[11px] rotate-180"/>
                </div>
                <div 
                    className={cn(btnGeneralStyles, '')}
                    onClick={handleOperatorBtn}
                >
                    <Woman className="w-full h-full"/>
                </div>
            </div>
        </PageLayout>
    );
}
